/**
 * @class
 * @extends mkE.Base
 */
T.CorporatePackages = Class(
	/**
	 * @lends {T.CorporatePackages#}
	 */
	{
		__construct: function ( key ) {
			this.key = key;
			this.node = mkE({tag: 'div'});
			this.draw();
		},

		draw() {
			if( screen.width <= 768 ) {
				this._drawMobile();
			} else {
				this._drawWeb();
			}
		},

		_drawMobile() {
			let packageStandard = [], packageCustom = [];
			const length = Number(D.Lang.get(`${this.key}.options.list.count`));
			for( let i = 0; i < length; i++ ) {
				packageStandard.push({
					tag: 'div',
					className: 'row',
					els: [
						{
							tag: 'div',
							els: [
								D.Lang.get(`${this.key}.options.list.${i}.col`),
								{
									tag: 'span',
									className: 'tippy',
									attr: {'data-tippy-content': D.Lang.get(`${this.key}.options.list.${i}.col_help`)},
									els: [
										D.svgIcon('round-info')
									]
								}
							]
						},
						{
							tag: 'div',
							els: [this._formatText(`${this.key}.options.list.${i}.rg`, i)]
						}
					]
				});
				packageCustom.push({
					tag: 'div',
					className: 'row',
					els: [
						{
							tag: 'div',
							els: [
								D.Lang.get(`${this.key}.options.list.${i}.col`),
								{
									tag: 'span',
									className: 'tippy',
									attr: {'data-tippy-content': D.Lang.get(`${this.key}.options.list.${i}.col_help`)},
									els: [
										D.svgIcon('round-info')
									]
								}
							]
						},
						{
							tag: 'div',
							els: [this._formatText(`${this.key}.options.list.${i}.custom`)]
						}
					]
				});
			}
			this.node = mkE({
				tag: 'div',
				className: 'corporate-packages',
				els: [
					{
						tag: 'h2',
						text: D.Lang.get(this.key + '.options.h2')
					},
					{
						tag: 'div',
						className: 'block block-mobile',
						els: [
							{
								tag: 'div',
								className: 'header',
								els: [
									{
										tag: 'h3',
										els: [
											D.Lang.get(this.key + '.options.rg.title'),
											{
												tag: 'span',
												className: 'tippy',
												attr: {'data-tippy-content': D.Lang.get(`${this.key}.options.rg.title.help`)},
												els: [
													D.svgIcon({
														icon: 'round-info',
														color: 'blue',
														size: 24
													})
												]
											}
										]
									},
									formatTextNode(mkE({
										tag: 'p',
										className: 'price',
										text: D.Lang.get(this.key + '.options.rg.price')
									}))
								]
							},
							{
								tag: 'div',
								className: 'body',
								style: {
									display: 'none'
								},
								els: packageStandard
							},
							{
								tag: 'div',
								className: 'footer',
								els: [
									{
										tag: 'a',
										className: 'show-more',
										text: D.Lang.get(this.key + '.options.show_more'),
										onclick: this._onClickToggle
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'block block-mobile',
						els: [
							{
								tag: 'div',
								className: 'header',
								els: [
									{
										tag: 'h3',
										els: [
											D.Lang.get(this.key + '.options.custom.title'),
											{
												tag: 'span',
												className: 'tippy',
												attr: {'data-tippy-content': D.Lang.get(`${this.key}.options.custom.title.help`)},
												els: [
													D.svgIcon({
														icon: 'round-info',
														color: 'blue',
														size: 24
													})
												]
											}
										]
									},
									formatTextNode(mkE({
										tag: 'p',
										className: 'price',
										text: D.Lang.get(this.key + '.options.custom.price')
									}))
								]
							},
							{
								tag: 'div',
								className: 'body',
								style: {
									display: 'none'
								},
								els: packageCustom
							},
							{
								tag: 'div',
								className: 'footer',
								els: [
									{
										tag: 'a',
										className: 'show-more',
										text: D.Lang.get(this.key + '.options.show_more'),
										onclick: this._onClickToggle
									}
								]
							}
						]
					}
				]
			}).replace(this.node);
		},

		_drawWeb() {
			const tbody = [];
			const length = Number(D.Lang.get(`${this.key}.options.list.count`));
			for( let i = 0; i < length; i++ ) {
				tbody.push({
					tag: 'tr',
					els: [
						{
							tag: 'td',
							els: [
								D.Lang.get(`${this.key}.options.list.${i}.col`),
								{
									tag: 'span',
									className: 'tippy',
									attr: {'data-tippy-content': D.Lang.get(`${this.key}.options.list.${i}.col_help`)},
									els: [
										D.svgIcon('round-info')
									]
								}
							]
						},
						{
							tag: 'td',
							els: [this._formatText(`${this.key}.options.list.${i}.rg`, i)]
						},
						{
							tag: 'td',
							els: [this._formatText(`${this.key}.options.list.${i}.custom`)]
						}
					]
				});
			}

			this.node = mkE({
				tag: 'div',
				className: 'corporate-packages',
				els: [
					{
						tag: 'h2',
						text: D.Lang.get(this.key + '.options.h2')
					},
					{
						tag: 'table',
						els: [
							{
								tag: 'thead',
								els: [
									{
										tag: 'tr',
										els: [
											{
												tag: 'td'
											},
											{
												tag: 'td',
												els: [
													{
														tag: 'h3',
														els: [
															D.Lang.get(this.key + '.options.rg.title'),
															{
																tag: 'span',
																className: 'tippy',
																attr: {'data-tippy-content': D.Lang.get(`${this.key}.options.rg.title.help`)},
																els: [
																	D.svgIcon({
																		icon: 'round-info',
																		color: 'blue',
																		size: 24
																	})
																]
															}
														]
													},
													formatTextNode(mkE({
														tag: 'p',
														className: 'price',
														text: D.Lang.get(this.key + '.options.rg.price')
													})),
													{
														tag: 'a',
														className: 'button button-pink',
														onclick() {
															D.scrollIntoView(document.querySelector('.corporate-form-wrapper'));
														},
														text: D.Lang.get(this.key + '.options.contact')
													}
												]
											},
											{
												tag: 'td',
												els: [
													{
														tag: 'h3',
														els: [
															D.Lang.get(this.key + '.options.custom.title'),
															{
																tag: 'span',
																className: 'tippy',
																attr: {'data-tippy-content': D.Lang.get(`${this.key}.options.custom.title.help`)},
																els: [
																	D.svgIcon({
																		icon: 'round-info',
																		color: 'blue',
																		size: 24
																	})
																]
															}
														]
													},
													formatTextNode(mkE({
														tag: 'p',
														className: 'price',
														text: D.Lang.get(this.key + '.options.custom.price')
													})),
													{
														tag: 'a',
														className: 'button button-pink',
														onclick() {
															D.scrollIntoView(document.querySelector('.corporate-form-wrapper'));
														},
														text: D.Lang.get(this.key + '.options.contact')
													}
												]
											}
										]
									}
								]
							},
							{
								tag: 'tbody',
								els: tbody
							}
						]
					}
				]
			}).replace(this.node);
		},

		_formatText( key, i ) {
			let text = D.Lang.get(key, ' ');
			if( i === 0 ) {
				return {
					tag: 'a',
					onclick: this._showEventList,
					els: [
						text,
						D.svgIcon('double-arrow-right')
					]
				};
			}
			if( text === 'x' ) {
				return D.svgIcon({
					icon: 'round-check',
					color: 'green'
				});
			} else if( text === ' ' ) {
				return '';
			}
			return text;
		},

		_onClickToggle( e ) {
			const target = e.target;
			const body = target.closest('.block').querySelector('div.body');
			if( body.style.display === 'none' ) {
				body.style.display = '';
				setNodeText(target, D.Lang.get(this.key + '.options.show_less'));
			} else {
				body.style.display = 'none';
				setNodeText(target, D.Lang.get(this.key + '.options.show_more'));
			}
		},

		_showEventList() {
			this._modal = new T.Popup({
				className: 'popup-share popup-corporate-events'
			});
			const el = new T.CorporatePackagesSearchEvents({
				onClickEmpty: () => {
					this._modal.close();
					D.scrollIntoView(document.querySelector('.corporate-form-wrapper'));
				},
				onClose: () => {
					this._modal.openOnBack = true;
					this._modal.close();
				},
				hideFilter: this.key === 'teambuilding',
				isVirtual: this.key === 'teambuilding',
				key: this.key
			});
			this._modal.setContent(el.node);
			this._modal.open();
		},

		onShow() {
			if( tippy ) {
				tippy('.tippy');
			}
		},

		onBack() {
			if( this._modal && this._modal.openOnBack ) {
				this._modal.openOnBack = false;
				this._modal.open();
			}
		}
	},
	mkE.Base
);


/**
 * @class
 * @extends mkE.Base
 */
T.CorporatePackagesSearchEvents = Class(
	/**
	 * @lends {T.CorporatePackagesSearchEvents#}
	 */
	{
		/**
		 * @param {{onClickEmpty:Function,onClose:Function,hideFilter:Boolean,isVirtual:Boolean,key:String}} par
		 * @private
		 */
		__construct( par ) {
			this.onClickEmpty = par.onClickEmpty;
			this.onClose = par.onClose;
			this.hideFilter = par.hideFilter || false;
			this.key = par.key;
			const apiCall = new DR.ApiCall();
			let defaultCountry = D.LANG;
			if( par.isVirtual ) {
				defaultCountry = 'home';
			} else if( D.LANG === 'et' ) {
				defaultCountry = 'ee';
			} else if( D.LANG === 'en' ) {
				defaultCountry = null;
			}
			this._searchEventsAutoComplete = new T.SearchEvents.AutoComplete({
				onChange: this._onSearch,
				disableDirectLinks: true,
				isVirtual: par.isVirtual
			});
			this._searchEventsFilter = new T.SearchEvents.Filter({
				sortType: DR.events.Search.SORTTYPE_NEWEST,
				country: defaultCountry,
				onChange: this._onSearch,
				apiCall: apiCall,
				isVirtual: par.isVirtual
			});
			this.node = mkE({
				tag: 'div',
				className: 'corporate-search',
			});
			if( this.hideFilter ) {
				addClassName(this.node, 'hide-filter');
			}
			apiCall.onLoad = () => {
				this._onSearch();
			};
			this._isMobile = screen.width < 768;
			this._draw();
			apiCall.call();
		},

		close() {
			if( this.onClose ) {
				this.onClose();
			}
		},

		_draw() {
			if( this._isMobile ) {
				this._drawMobile();
			} else {
				this._drawWeb();
			}
		},

		_drawMobile() {
			mkE({
				tag: 'div',
				className: 'search_events',
				els: [
					{
						tag: 'h2',
						text: D.Lang.get('corporate.popup.events.h1')
					},
					this._searchEventsAutoComplete
				]
			}).append(this.node);

			mkE({
				tag: 'div',
				className: 'events-list event-list-mobile',
				onscroll: this._onScroll,
				els: [
					this._listNode = mkE({
						tag: 'div'
					}),
					{
						tag: 'div',
						className: 'button-container load_more',
						els: [
							this._loadMoreNode = mkE({
								tag: 'a',
								className: 'button button-turquoise',
								onclick: this._loadMore,
								text: D.Lang.get('load_more'),
								style: {
									display: 'none'
								}
							})
						]
					}
				]
			}).append(this.node);
		},

		_drawWeb() {
			mkE({
				tag: 'div',
				className: 'search_events',
				els: [
					{
						tag: 'div',
						className: 'header-title',
						els: [
							{
								tag: 'h2',
								text: D.Lang.get('corporate.popup.events.h1')
							},
							this._searchEventsAutoComplete
						]
					},
					this._searchEventsFilter
				]
			}).append(this.node);

			mkE({
				tag: 'div',
				className: 'events-list event-list-web',
				els: [
					{
						tag: 'div',
						className: 'events-list-header',
						els: [
							{tag: 'div', text: D.Lang.get('corporate.popup.events.list.th0')},
							{tag: 'div', text: D.Lang.get('corporate.popup.events.list.th1')},
							this.key !== 'teambuilding' ? {tag: 'div', text: D.Lang.get('corporate.popup.events.list.th2')} : null,
							{tag: 'div', text: D.Lang.get('corporate.popup.events.list.th3')},
							{tag: 'div', text: D.Lang.get('corporate.popup.events.list.th4')},
							{tag: 'div', text: D.Lang.get('corporate.popup.events.list.th5')}
						]
					},
					{
						tag: 'div',
						className: 'events-list-scroll-container',
						onscroll: this._onScroll,
						els: [
							this._listNode = mkE({
								tag: 'div',
								className: 'events-list-container'
							}),
							{
								tag: 'div',
								className: 'button-container load_more',
								els: [
									this._loadMoreNode = mkE({
										tag: 'a',
										className: 'button button-turquoise',
										onclick: this._loadMore,
										text: D.Lang.get('load_more'),
										style: {
											display: 'none'
										}
									})
								]
							}
						]
					}
				]
			}).append(this.node);
		},

		_onScroll() {
			if( D.inScreen(this._loadMoreNode) ) {
				this._loadMore();
			}
		},

		_onSearch() {
			if( typeof this._mSearchEvents === "undefined" ) {
				this._mSearchEvents = new DR.events.Search();
				this._mSearchEvents.select = [
					new DR.events.select.SearchRe().events(),
					new DR.events.select.Event().id().title().image().showResults().region().startTime().endTime().minPlayers().maxPlayers().hasLandingPage()
						.seoTitle().description().hasImage().status().description().settings().ticket().hasLandingImage().landingImage().hasTeam().userRating().stats().languages(),
					new DR.roadgames.select.Image().small()
				];
				this._mSearchEvents.onLoad = this._mSearchEventsRe;
			}
			if( this._mSearchEvents.processing ) {
				return;
			}
			D.loadingOverlay(this._listNode.parentNode, {delay: true});

			this._mSearchEvents.pg = 1;
			this._mSearchEvents.count = 10;
			this._mSearchEvents.sortType = this._searchEventsFilter.getSortType();
			this._mSearchEvents.transportType = this._searchEventsFilter.getTransportType();
			this._mSearchEvents.country = this._searchEventsFilter.getCountry();
			this._mSearchEvents.tag = this._searchEventsAutoComplete.valueTag();
			this._mSearchEvents.kw = this._searchEventsAutoComplete.value();
			this._mSearchEvents.call();
		},

		_mSearchEventsRe() {
			D.removeLoadingOverlay(this._listNode.parentNode);
			if (this._mSearchEvents.pg === 1) {
				this._listNode.parentNode.scrollTo(0, 0);
				clearNode(this._listNode);
			}
			const m = this._mSearchEvents;
			if( m.re.events.length ) {
				for( let i = 0; i < m.re.events.length; i++ ) {
					const listItem = m.re.events[i];
					this._drawListItem(listItem).append(this._listNode);
				}
			} else if( m.pg === 1 ) {
				mkE({
					tag: 'div',
					className: 'empty',
					els: [
						{
							tag: 'h3',
							text: D.Lang.get('corporate.popup.events.list.empty.title')
						},
						{
							tag: 'p',
							text: D.Lang.get('corporate.popup.events.list.empty.descr')
						},
						{
							tag: 'a',
							onclick: this._onClickEmpty,
							className: 'button button-pink',
							text: D.Lang.get('corporate.popup.events.list.empty.btn')
						}
					]
				}).append(this._listNode);
			}
			this._loadMoreNode.style.display = m.re.events.length > 0 && m.re.events.length >= m.count ? '' : 'none';
		},

		_onClickEmpty() {
			this.onClickEmpty();
		},

		_loadMore() {
			if( this._mSearchEvents.processing ) {
				return false;
			}
			this._mSearchEvents.pg++;
			this._mSearchEvents.call();
			return false;
		},

		/**
		 *
		 * @param {DR.events.struct.Event} event
		 * @returns {int}
		 * @private
		 * @todo refactor
		 */
		_getEventTasksCount( event ) {
			let c = 0;
			const tasks = [
				'hasPhotoMatching',
				'hasHotCold',
				'hasQuestions',
				'hasPacman',
				'hasTreasure',
				'hasCrazyWolves',
				'hasBrainTeaser',
				'hasDetective',
				'hasCoder',
				'hasGoldDigger'
			];
			for( let i = 0; i < tasks.length; i++ ) {
				const task = tasks[i];
				if( event.settings[task] ) {
					c++;
				}
			}
			return c;
		},

		/**
		 *
		 * @param {DR.events.struct.Event} event
		 * @returns {string}
		 * @private
		 */
		_getEventDuration( event ) {
			let hours = Math.ceil((event.endTime - event.startTime) / 3600);
			if( event.settings.gameType === 'anytime' ) {
				hours = Math.ceil(event.settings.gameTime / 60);
			}
			return hours + 'h';
		},

		/**
		 * @param {DR.events.struct.Event} event
		 * @returns {string|Number|*|null}
		 * @private
		 */
		_getEventParticipantInfo( event ) {
			if( event.minPlayers === event.maxPlayers ) {
				return event.minPlayers;
			}
			return event.minPlayers + '-' + event.maxPlayers;
		},

		/**
		 * @param {DR.events.struct.Event} event
		 * @returns {string|Number|*|null}
		 * @private
		 */
		_getEventRating( event ) {
			if( event.startTime < D.TIME && event.stats.players >= 10 ) {
				return {
					tag: 'div',
					className: 'rating',
					els: [
						{
							tag: 'span',
							els: [
								{
									tag: 'b',
									text: event.userRating.rating ? event.userRating.rating.toFixed(2) : '-'
								},
								event.userRating.users ? ' (' + event.userRating.users + ')' : ''
							]
						},
						' · ',
						D.Lang.nget(event.stats.players, 'corporate.popup.events.list.event.users_played')
					]
				};
			} else if( !event.showResults ) {
				return {
					tag: 'div',
					className: 'rating rating-new',
					els: [
						{
							tag: 'span',
							els: [
								{
									tag: 'b',
									text: D.Lang.get('events.new_event')
								}
							]
						},
						event.stats.players > 10 ? {
							tag: 'span',
							els: [
								' · ',
								D.Lang.nget(event.stats.players, 'corporate.popup.events.list.event.users_played')
							]
						} : ''
					]
				};
			} else {
				return '';
			}
		},

		/**
		 * @param {DR.events.struct.Event} event
		 * @returns {mkE.Base}
		 * @private
		 */
		_drawListItem( event ) {
			if( this._isMobile ) {
				return this._drawListItemMobile(event);
			} else {
				return this._drawListItemWeb(event);
			}
		},
		/**
		 * @param {DR.events.struct.Event} event
		 * @returns {mkE.Base}
		 * @private
		 */
		_drawListItemMobile( event ) {
			return mkE({
				tag: 'div',
				className: 'event',
				onclick: this._onClickReadMore,
				els: [
					{
						tag: 'div',
						className: 'event-top',
						els: [
							{
								tag: 'div',
								className: 'event-image',
								els: [
									{
										tag: 'a',
										href: D.url('/event/' + event.seoTitle),
										onclick: this.close.bind(this),
										els: [
											{
												tag: 'img',
												src: event.image.small
											}
										]
									}
								]
							},
							{
								tag: 'div',
								className: 'event-info',
								els: [
									{
										tag: 'div',
										className: 'event-title',
										els: [
											{
												tag: 'a',
												href: D.url('/event/' + event.seoTitle),
												onclick: this.close.bind(this),
												text: event.title
											}
										]
									},
									this._getEventRating(event)
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'event-data',
						els: [
							{
								tag: 'div',
								els: [
									{tag: 'div', text: D.Lang.get('corporate.popup.events.list.th1')},
									{tag: 'div', text: this._getEventTasksCount(event)}
								]
							},
							this.key !== 'teambuilding' ? {
								tag: 'div',
								els: [
									{tag: 'div', text: D.Lang.get('corporate.popup.events.list.th2')},
									{tag: 'div', text: D.Lang.get('event.transport.' + event.settings.transportType)}
								]
							} : '',
							{
								tag: 'div',
								els: [
									{tag: 'div', text: D.Lang.get('corporate.popup.events.list.th3')},
									{tag: 'div', text: event.languages.join(', ')}
								]
							},
							{
								tag: 'div',
								els: [
									{tag: 'div', text: D.Lang.get('corporate.popup.events.list.th4')},
									{tag: 'div', text: this._getEventDuration(event)}
								]
							},
							{
								tag: 'div',
								els: [
									{tag: 'div', text: D.Lang.get('corporate.popup.events.list.th5')},
									{tag: 'div', text: this._getEventParticipantInfo(event)}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'event-description',
						els: [
							formatTextNode(mkE({
								tag: 'div',
								text: event.description
							}))
						]
					}
				]
			});
		},
		/**
		 * @param {DR.events.struct.Event} event
		 * @returns {mkE.Base}
		 * @private
		 */
		_drawListItemWeb( event ) {
			return mkE({
				tag: 'div',
				className: 'event',
				onclick: this._onClickReadMore,
				els: [
					{
						tag: 'div',
						className: 'event-image',
						els: [
							{
								tag: 'span',
								els: [
									{
										tag: 'img',
										src: event.image.small
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'event-info',
						els: [
							{
								tag: 'div',
								className: 'event-title',
								els: [
									{
										tag: 'span',
										text: event.title
									}
								]
							},
							{
								tag: 'div',
								text: this._getEventTasksCount(event)
							},
							this.key !== 'teambuilding' ? {
								tag: 'div',
								text: D.Lang.get('event.transport.' + event.settings.transportType)
							} : '',
							{
								tag: 'div',
								className: 'event-languages',
								text: event.languages.join(', ')
							},
							{
								tag: 'div',
								text: this._getEventDuration(event)
							},
							{
								tag: 'div',
								text: this._getEventParticipantInfo(event)
							}
						]
					},
					this._getEventRating(event),
					{
						tag: 'div',
						className: 'event-description',
						els: [
							formatTextNode(mkE({
								tag: 'div',
								text: event.description
							}))
						]
					}
				]
			});
		},
		_onClickReadMore( e ) {
			toggleClassName(e.currentTarget, 'expanded');
		}
	},
	mkE.Base
);